
/* eslint-disable  jsx-a11y/label-has-associated-control , prefer-destructuring */

import React, { useEffect, useMemo, useState } from "react";
import "./EvaluatorReportFilter.css";


const ChallengeAllReport = ({
  onDownload,
  isLoading = false,
}) => {
  



  /**
   * Download report.
   */
  const handleDownload = async () => {
   
    try {
      await onDownload('challenges');
    } catch(err){
      console.log("Error :" , err )
    }
    
  };


  return (
     <section
      className="evaluator-report-filter"
      aria-labelledby="evaluator-report-title"
    >
      <div className="vf-challenge-filter-header">
        <h2
          id="evaluator-report-title"
          className="vf-challenge-filter-title"
        >
         ALL Challenge Report
        </h2>

        <p className="vf-challenge-filter-subtitle">
          Download all Challenge List data.
        </p>
      </div>


      {/* Buttons */}
      <div className="vf-evaluator-filter-actions">
        <button
          type="button"
          className="vf-evaluator-report-button"
          onClick={handleDownload}
          disabled={isLoading}
        >
          {isLoading
            ? "Downloading..."
            : "Download All Challenge Report"}
        </button>       
      </div>

    </section>
    
  );
};

export default ChallengeAllReport;